const SvgHamburgerIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      stroke="#333"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M20 7.07H4M20 12.07H4M20 17.07H4"
    />
  </svg>
);
export default SvgHamburgerIcon;
